(function () {
  'use strict';
  var source = document.currentScript && document.currentScript.dataset.nsWidgetSrc;
  if (!source) return; // Native contact-page links remain the fallback.
  var loading;
  var opening;

  function chatReady() {
    return document.getElementById('mtb-chat-btn') && document.getElementById('mtb-chat-panel');
  }

  function syncHomeContact(available) {
    var home = document.querySelector('.nsfh');
    if (!home) return;
    var chat = home.querySelector('.nsfh__human-actions a[data-ns-open-cmsa][href]');
    var phone = home.querySelector('.nsfh__human-actions a[href="tel:+18883487352"]');
    var ready = available !== false && chatReady() && chat && phone &&
      /^\/(?!\/)/.test(chat.getAttribute('href') || '');
    home.toggleAttribute('data-ns-inline-contact-ready', !!ready);
  }

  function loadChat() {
    if (chatReady()) {
      syncHomeContact();
      return Promise.resolve();
    }
    if (window.__mtbChatLoaded) return Promise.reject(new Error('Chat unavailable'));
    if (loading) return loading;
    var attempt = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[src="' + source + '"]');
      var timer;
      var done = false;
      function finish(error) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        script.removeEventListener('load', ready);
        script.removeEventListener('error', failed);
        if (error && script.dataset.nsCmsaLoader !== undefined) script.remove();
        syncHomeContact(!error);
        if (error) reject(error);
        else resolve();
      }
      function ready() {
        finish(chatReady() ? null : new Error('Chat unavailable'));
      }
      function failed() {
        finish(new Error('Chat unavailable'));
      }
      if (!script) {
        script = document.createElement('script');
        script.src = source;
        script.defer = true;
        script.dataset.nsCmsaLoader = '';
      }
      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', failed, { once: true });
      timer = setTimeout(function () { finish(new Error('Chat timeout')); }, 12000);
      if (!script.isConnected) document.body.appendChild(script);
    });
    loading = attempt;
    attempt.catch(function () {
      if (loading === attempt) loading = null;
    });
    return attempt;
  }

  function openChat() {
    if (opening) return opening;
    opening = loadChat().then(function () {
      var button = document.getElementById('mtb-chat-btn');
      var panel = document.getElementById('mtb-chat-panel');
      if (!button || !panel) throw new Error('Chat unavailable');
      if (!panel.classList.contains('open')) button.click();
      if (!panel.classList.contains('open')) throw new Error('Chat unavailable');
      var input = document.getElementById('mtb-in');
      if (input && window.innerWidth >= 768 &&
          !(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) input.focus();
    });
    opening.then(function () { opening = null; }, function () { opening = null; });
    return opening;
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-ns-open-cmsa]');
    if (!target || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (target.getAttribute('aria-busy') === 'true') return;
    target.setAttribute('aria-busy', 'true');
    var status = document.createElement('span');
    status.className = 'ns-contact-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.style.cssText = 'display:block;font-size:14px;line-height:1.4;margin:6px 0;color:inherit;';
    target.insertAdjacentElement('afterend', status);
    status.textContent = (document.documentElement.lang || 'es').toLowerCase().indexOf('en') === 0
      ? 'Opening chat…' : 'Abriendo chat…';
    function clearStatus() {
      target.removeAttribute('aria-busy');
      status.remove();
    }
    openChat().then(function () {
      clearStatus();
    }, function () {
      clearStatus();
      syncHomeContact(false);
      var fallback = target.getAttribute('href');
      if (fallback) window.location.assign(fallback);
    });
  });

  // The existing inline anchors now have their delegated loader. Hide no
  // launcher until both fallback paths and the native widget nodes exist.
  syncHomeContact();
  window.addEventListener('pageshow', syncHomeContact);
  document.addEventListener('shopify:section:load', syncHomeContact);

  function schedule() {
    var idle = window.requestIdleCallback || function (callback) { return setTimeout(callback, 1); };
    idle(function () {
      setTimeout(function () { loadChat().catch(function () {}); }, 10000);
    }, { timeout: 4000 });
  }
  if (new URLSearchParams(window.location.search).get('chat') === 'abrir') {
    loadChat().catch(function () {});
  } else if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
